<template>
    <el-drawer :title="isEdit ? '编辑智能体分类' : '添加智能体分类'" :visible.sync="drawer" :modal="true"
        :wrapperClosable="false" size="600px" @close="closeDrawer" :modal-append-to-body="false" :direction="direction">

        <!-- title -->
        <div class="drawer_form">

            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">

                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <div class="card-container">
                            <div class="section">
                                <div class="section-title">基本信息</div>
                            </div>
                            <el-form-item label="分类编码" prop="categoryCode">
                                <el-input type="text" v-model="form.categoryCode" autocomplete="off"
                                    placeholder="请输入分类编码"></el-input>
                            </el-form-item>
                            <el-form-item label="分类名称" prop="categoryName">
                                <el-input type="text" v-model="form.categoryName" autocomplete="off"
                                    placeholder="请输入分类名称"></el-input>
                            </el-form-item>
                            <el-form-item label="描述" prop="description">
                                <el-input type="textarea" v-model="form.description" autocomplete="off"
                                    placeholder="请输入分类描述" rows="4"></el-input>
                            </el-form-item>
                        </div>

                        <el-divider></el-divider>

                        <div class="card-container">
                            <div class="section">
                                <div class="section-title">接口配置</div>
                            </div>
                            <el-form-item label="接口地址" prop="url">
                                <el-input type="text" v-model="form.url" autocomplete="off"
                                    placeholder="请输入智能体接口地址"></el-input>
                            </el-form-item>
                            <el-form-item label="令牌(Token)" prop="token">
                                <el-input type="text" v-model="form.token" autocomplete="off"
                                    placeholder="请输入接口访问令牌"></el-input>
                            </el-form-item>
                        </div>

                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button :loading="loading" @click="onSubmit" class="common-button">{{ isEdit ? '更新' : '添加'
                        }}</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>

</template>

<script>
import { categoryGet, categorySave } from '@/request/api/agents.js';
export default {
    data() {
        return {
            drawer: true, //表单
            direction: 'rtl',//抽屉方向
            loading: false,
            isEdit: false, // 判断是编辑还是新增
            form: {
                id: '',
                categoryCode: '',
                categoryName: '',
                description: '',
                url: '',
                token: '',
            },
            rules: {
                categoryCode: [
                    { required: true, message: '请输入分类编码', trigger: 'blur' },
                ],
                categoryName: [
                    { required: true, message: '请输入分类名称', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
        // 判断是否为编辑模式
        this.isEdit = !!this.$route.query.id
        this.form.id = this.$route.query.id || ''
        this.init()
    },
    methods: {
        init() {
            // 如果是编辑模式，加载数据
            if (this.isEdit) {
                categoryGet({ id: this.form.id }).then(res => {
                    if (!res.data) return console.error("res.data is null");
                    Object.keys(this.form).forEach(item => {
                        if (Object.prototype.hasOwnProperty.call(this.form, item) && Object.prototype.hasOwnProperty.call(res.data, item)) {
                            this.form[item] = res.data[item]
                        }
                    })
                })
            }
        },
        onSubmit() {
            this.$refs['form'].validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.req();
            });
        },

        //req
        req() {
            this.loading = true;
            categorySave(this.form).then(res => {
                this.loading = false;
                if (res.code != 0) {
                    return this.$notify({ title: '失败', message: res.msg, type: 'error' });
                }
                this.$notify({
                    title: '成功',
                    message: this.isEdit ? "更新成功" : "添加成功",
                    type: 'success'
                });
                this.$router.go(-1);
            }).catch(err => {
                this.loading = false;
                console.error('保存数据失败:', err);
                this.$notify({ title: '失败', message: '保存数据失败，请重试', type: 'error' });
            });
        },

        //关闭抽屉
        closeDrawer() {
            this.$router.go(-1)
        }
    }

}
</script>


<style lang="less" scoped>
.drawer_form {
    width: 96%;
    margin: auto;
}

.section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .section-title {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
    }
}

/deep/ .el-divider {
    background: #409eff;
}
</style>
